import {RubricAnswer} from '../../types';

export const createGridProgressBarData = (rubricAnswers: RubricAnswer[], rubricCriteriaCount: number, totalPossible: number) => {
	const levelsCount = totalPossible / rubricCriteriaCount;

	return rubricAnswers?.map(answer => ({value: answer?.score, maxValue: levelsCount})) || [];
};
